export const TOAST_PERSISTENCE_TIME = 5000;
